<template>
  <div class="form-box">
    <el-form ref="scopedForm" :model="scopedForm" :rules="rules" label-width="118px" v-if="ifForm==1">
      <el-form-item label="当前邮箱：" prop="oldEmail">
        <el-input v-model="scopedForm.oldEmail" disabled="disabled"></el-input>
      </el-form-item>
      <el-form-item label="新邮箱号：" prop="newEmail">
        <el-input v-model="scopedForm.newEmail"></el-input>
      </el-form-item>
      <!-- <el-form-item label="图形验证码：" prop="imgCode">
        <el-input v-model="scopedForm.imgCode" class="imgCode"></el-input>
        <img :src="imgCodeSrc" alt class="imgCodeBtn" @click="getImgCode()" />
      </el-form-item> -->
      <el-form-item label="邮箱验证码：" prop="numCode">
        <el-input v-model="scopedForm.numCode" :class="['numCode', {load: validCode._load}]"></el-input>
        <el-button class="numCodeBtn" :loading="validCode._load" @click="sendSMS">{{validCode._html}}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "editEmail",
  props: ["ifForm", "isCall", "params"],
  data () {
    return {
      rules: {
        oldEmail: [{ required: true, validator: isEmail, trigger: "blur" }],
        newEmail: [{ required: true, validator: isEmail, trigger: "blur" }],
        // imgCode: [
        //   { required: true, message: "*请输入图形验证码", trigger: "blur" }
        // ],
        numCode: [
          { required: true, message: "*请输入短信验证码", trigger: "blur" }
        ]
      },
      scopedForm: {
        // phonePrefix: "1",
        oldEmail: "",
        newEmail: "",
        // imgCode: "",
        numCode: ""
      },
      imgCodeSrc: this.baseURL + "user/getVerifyCodeImage?t=" + +new Date(),
      imgCodeUrl: this.baseURL + "user/getVerifyCodeImage",
      validCode: {
        timeMax: 60,
        html: "获取验证码",
        load: "{time}秒后重试",
        _html: "获取验证码",
        _load: false,
        _time: 60,
        _inter: null
      }
    };
  },
  components: {},
  watch: {
    isCall () {
      this.resetForm();
    }
  },
  created () {
    if (this.params) {
      this.scopedForm.oldEmail = this.params.email;
    }
  },
  methods: {
    resetForm () {
      // 清空
      if (this.$refs.scopedForm) {
        this.$refs.scopedForm.resetFields();
      }
    },
    submit (callback) {
      // 提交
      let that = this
      this.$refs.scopedForm.validate(valid => {
        if (valid) {
          var params = {
            // oldEmail: this.scopedForm.oldEmail,
            email: that.scopedForm.newEmail,
            // imgCode: this.scopedForm.imgCode,
            verificationCode: this.scopedForm.numCode,
            platformType: 0
          };
          this.catReq1Service("/api/v1/user/changeLoginEmail", params)
            .then(response => {
              if (!response.success) {
                return;
              }
              callback && callback(this.scopedForm.newEmail);
            });
        } else {
          return false;
        }
      });
    },
    sendSMS () {
      var verify = true;
      let that = this
      this.$refs.scopedForm.validateField(["oldEmail", "newEmail"], errTip => {
        if (errTip) {
          // 会调用多次
          verify = false;
        }
      });
      if (verify) {
        that.validCode._load = true;

        let params = {
          // oldPhone: this.scopedForm.oldPhone,
          email: that.scopedForm.newEmail,
          platformType: 0
        };

        that.catReq1Service("/user/send_email_code", params)
          .then(response => {
            if (!response.success) {
              return;
            }
            this.startCountdown();
          })
          .catch(error => {
            this.validCode._load = false;
            this.endCountdown();
          });
      }
    },
    startCountdown () {
      clearInterval(this._inter);
      this.startCountdownCore();
      this._inter = setInterval(() => {
        this.startCountdownCore();
        if (this.validCode._time <= 0) {
          this.endCountdown();
        }
      }, 1000);
    },
    startCountdownCore () {
      this.validCode._time--;
      this.validCode._html = this.validCode.load.replace(
        /\{time\}/g,
        ("0000" + this.validCode._time).substr(-2, 2)
      );
    },
    endCountdown () {
      clearInterval(this._inter);
      this.validCode._html = this.validCode.html; // 获取验证码
      this.validCode._time = this.validCode.timeMax; // 60
      this.validCode._load = false;
      this.validCode._inter = null;
    },
    getImgCode () {
      this.imgCodeSrc = this.imgCodeUrl + "?t=" + +new Date();
    },
    onSubmit () {
      // // console.log(this.ifForm, "submit!");
    }
  }
};
function isEmail (rule, value, next) {
  var reg = /^(\w)+(\.\w+)*@(\w)+((\.\w{2,3}){1,3})$/;
  if (value === "" || value == void 0) {
    next("*请输入邮箱");
  } else if (!reg.test(value)) {
    next("*请输入正确的邮箱");
  } else {
    next();
  }
}
</script>

<style lang="less" scoped>
.form-box {
  margin: 0 auto;
  width: 378px;
  text-align: left;
  padding: 0 50px;
}
.imgCode {
  width: 166px;
}
.numCode {
  width: 145px;
  &.load {
    width: 125px;
  }
}
.imgCodeBtn {
  width: 84px;
  height: 36px;
  float: right;
  vertical-align: middle;
}
.numCodeBtn {
  font-size: 12px;
  padding: 12px 15px;
  color: rgba(69, 69, 69, 1);
  border: 1px solid rgba(69, 69, 69, 1);
  float: right;
}
</style>
<style>
.el-select .el-input {
  width: 75px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
</style>